<template>
    <div>
        <span class="rate" :class="getCssColorClass(row[column.data])">{{ row[column.data] }}</span>
    </div>
</template>

<script>

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        config: {
            type: Object,
            default: function() {
                return {
                    iconColor: ''
                }
            }
        },
        row: {
            type: Object,
        },
    },
    data() {
        return {

        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        getCssColorClass(value) {
            let classColor = 'bad';

            switch (parseInt(value)) {
                case 5:
                    classColor = 'good';
                    break;
                case 4:
                    classColor = 'average';
                    break;
            }

            return classColor;
        },
    }
}
</script>

<style lang="sass">
    .rate {
        color: #fff;
        padding: 5px;
        border-radius:5px;

        &.good {
           background-color: #43cb83;
        }
        &.average {
            background-color: #f9b954;
        }
        &.bad {
            background-color: #f57846;
        }
    }
</style>


// WEBPACK FOOTER //
// CommentRatingHighlightComponent.vue?3d47dc15